// extracted by mini-css-extract-plugin
export var button = "_h7-0";
export var donut = "_h7-1";
export var donutFill = "_h7-3";
export var donutTrack = "_h7-2";